import { QueryPaths } from 'src/common/gql/queryPaths';

/**
 * convert to absolute site core path
 * @param relativePath
 * @returns
 */
export function toSiteCorePath(relativePath: string | string[] | undefined): string {
    if (relativePath instanceof Array) {
        relativePath = relativePath.join('/');
    } else if (!relativePath) {
        relativePath = '';
    }
    const path = `${QueryPaths.SpecialBase}/${relativePath}`;
    return path;
}

export function withBasePath(subpath: string): string {
    const APP_BASE_PATH = process.env.NEXT_PUBLIC_APP_BASE_PATH;
    if (APP_BASE_PATH) {
        const path = `/${APP_BASE_PATH}${subpath}`;
        return path;
    } else {
        return subpath;
    }
}
